// extracted by mini-css-extract-plugin
export var actions = "_5-4";
export var brand = "_5-3";
export var header = "_5-0";
export var headerContent = "_5-1";
export var identity = "_5-5";
export var logo = "_5-2";